import resolveMlbTeamId from "./teamMlbId";

const MLB_LOGO_BASE = "https://www.mlbstatic.com/team-logos";

export const LOGO_VARIANTS = {
  default: "default",
  dark: "dark",
  darkPrimary: "darkPrimary",
};

/**
 * Build an MLB CDN logo URL for a team.
 * Team logos are hotlinked SVGs — no R2 or backend storage needed.
 *
 * @param {number|string} mlbTeamId - MLB team ID
 * @param {{ variant?: keyof typeof LOGO_VARIANTS }} [options]
 * @returns {string|null}
 */
export const getTeamLogoUrl = (mlbTeamId, { variant = LOGO_VARIANTS.dark } = {}) => {
  const id = resolveMlbTeamId(mlbTeamId);
  if (!id) return null;

  switch (variant) {
    case LOGO_VARIANTS.dark:
      return `${MLB_LOGO_BASE}/team-cap-on-dark/${id}.svg`;
    case LOGO_VARIANTS.darkPrimary:
      return `${MLB_LOGO_BASE}/team-primary-on-dark/${id}.svg`;
    case LOGO_VARIANTS.default:
    default:
      return `${MLB_LOGO_BASE}/${id}.svg`;
  }
};

/**
 * Resolve a team name or ID and return its logo URL.
 *
 * @param {number|string} teamNameOrId
 * @param {{ variant?: keyof typeof LOGO_VARIANTS }} [options]
 * @returns {string|null}
 */
export const getTeamLogoUrlForTeam = (teamNameOrId, options = {}) =>
  getTeamLogoUrl(resolveMlbTeamId(teamNameOrId), options);

export { resolveMlbTeamId };
export default getTeamLogoUrl;
